module.exports = __webpack_public_path__ + "static/Speeches-a6cacd82a698c073274665c2411e7771.webm";